<template>
   <div class="col">
      <div :class="className" class="card h-100" role="listitem">
         <img :src="imgUrl" aria-hidden="true" />
         <div class="card-body">
            <h2>{{ jobDomain.jobDomain1 }}</h2>
            <p>{{ jobDomain.jobDomainDescription }}</p>
         </div>
         <div class="card-footer">
            <div
               v-if="jobDomain.loadingCareers"
               class="spinner-border text-secondary"
               role="status"
            >
               <span class="sr-only">Loading</span>
            </div>
            <p v-else>
               <fragment v-if="!jobDomain.careerCount"
                  >Expand your search criteria for additional job roles</fragment
               >
               <!-- Replace router link with a simple <a> link but
               use @click to do the navigation so we can hide the tooltip -->
               <a
                  v-else
                  :aria-label="ariaLabel"
                  v-popover
                  ref="tooltip"
                  data-container="body"
                  data-toggle="popover"
                  data-trigger="hover"
                  data-placement="bottom"
                  data-content="View matching job roles in this domain"
                  @click="buttonClicked"
               >
                  view {{ jobDomain.careerCount }} {{ career }}
               </a>
            </p>
         </div>
      </div>
   </div>
</template>

<script>
import $ from 'jquery';

export default {
   /* eslint-disable vue/require-default-prop, vue/require-prop-types */
   name: 'CategoryCard',
   props: ['jobDomain'],
   computed: {
      className: function() {
         return `cat-${this.jobDomain.shortName}`;
      },
      imgUrl: function() {
         return require(`@/assets/images/icon-${this.jobDomain.shortName}.png`);
      },
      ariaLabel: function() {
         const replaceAmpersands = this.jobDomain.jobDomain1.replace(/&/, 'and');
         return `View ${this.jobDomain.careerCount} job roles in ${replaceAmpersands}`;
      },
      career: function() {
         if (this.jobDomain.careerCount === 1) {
            return 'job role';
         }
         return 'job roles';
      },
   },
   methods: {
      // use this to navigate, but hide the tooltip
      // before jumping to the next page
      buttonClicked: function(evt) {
         $(evt.target).popover('hide');
         // was used as a :to target for router-link
         this.$router.push({path: this.jobDomain.careerUrl});
      },
   },
};
</script>



// WEBPACK FOOTER //
// src/components/CategoryCard.vue